import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import { useLocation, useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { Button, Form } from "reactstrap";
import MyInput from "../../../MyComp/UI/form/MyInput";

import MyMobile from "../../../MyComp/UI/form/MyMobile";

import MySelect from "../../../MyComp/UI/form/MySelect";

import MyButton from "../../../MyComp/UI/form/MyButton";
import { StepHeader } from "./StepHeader";

import { toast } from "react-toastify";
import useLogout from "../../../hooks/useLogout";

import { listHospitalAPI, listHospitalDDAPI, listStoreDDAPI } from "../../../api/dropdown";
import { craeteHospitalProfile, createPharmacyStore, getZipDetailsAPI } from "../../../api/master/indes";
import MyTextArea from "../../../MyComp/UI/form/MyTextArea";
import { getHospitalStepOne } from "../../../api/lab";
import MyGmailAddressSearch from "../../../MyComp/UI/form/MyGmailAddressSearch";
import MyEmail from "../../../MyComp/UI/form/MyEmail";

const HospitalStepOne = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      agreed: false,
      medical_qualification: null,
      storeTypeDD: [],
      countryDD: [{ value: "India", label: "India" }],
      country: { value: "India", label: "India" },
      stateDD: [],
      cityDD: [],
      paymentModeDD: [
        {
          value: "card",
          label: "Card",
        },
        {
          value: "cash",
          label: "Cash",
        },
        {
          value: "net_banking",
          label: "Net Banking",
        },
        {
          value: "upi",
          label: "UPI",
        },
      ],
      deliveryRadiusDD: [
        {
          value: "1",
          label: "1 KM",
        },
        {
          value: "2",
          label: "2 KM",
        },
        {
          value: "3",
          label: "3 KM",
        },
        {
          value: "4",
          label: "4 KM",
        },
        {
          value: "5",
          label: "5 KM",
        },
        {
          value: "6",
          label: "6 KM",
        },
        {
          value: "7",
          label: "7 KM",
        },
        {
          value: "8",
          label: "8 KM",
        },
        {
          value: "9",
          label: "9 KM",
        },
        {
          value: "10",
          label: "10 KM",
        },
      ],

      store_image: null,
      store_img: null,

      pan_image: null,
      pan_img: null,

      drug_img: null,
      drug_image: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,

      catalog_image: null,
      catalog_img: null,

      fssai_image: null,
      fssai_img: null,

      cheque_image: null,
      cheque_img: null,

      objectionKeys: [],
      approvedKeys: [],

      degree: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],
      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });

  const [mode, setMode] = useState(location?.state?.mode || "Add");
  const doctorId = location?.state?.doctorId || "";
  const isLoading = watch("isLoading");
  const [loading, setLoading] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  console.log(location, "location");

  const onFormSubmit = (data) => {
    console.log(data, "form data");

    const bodyData = {
      name: data.name || "",
      email: data.email || "",
      hospitalTypeId: data.hospital_type?.value || "",
      registrationNumber: data.regsitration_number || "",
      mobile: data.hospital_mobile || "",
      contactPerson: data.contact_person || "",
      contactNumber: data.hospital_mobile || "",
      alternateContactNumber: data.alternate_mobile || "",

      addressLine1: data.hospital_address || "",
      addressLine2: data.address || "",

      // pincode: data.pin_code || "",

      pincode: data.pincode || "",
      state: data.state || "",
      district: data.district || "",
      country: "India",
      latitude: data.latitude || "",
      longitude: data.longitude || "",
      map_link: data.map_link || "",

      // latitude: data.latitude || "",/
      // longitude: data.longitude || "",
    };

    console.log(bodyData, "payload");

    if (mode === "Add" || mode === "Edit") {
      craeteHospitalProfile(bodyData).then((res) => {
        if (res?.data?.status === true) {
          toast.success(res.data.message);
          navigate("/hospital-registration/hospital-additional-details", {
            // state: { mode: "Add", hospitalId: res.data.data?.hospitalId },
            state: { mode: mode, hospitalId: mode === "Add" ? res.data.data?.hospitalId : location.state.hospitalid },
          });
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      });
    }
  };

  useEffect(() => {
    getHospitalType();
  }, []);
  const getHospitalType = (body) => {
    listHospitalDDAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("storeTypeDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("storeTypeDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  // useEffect(() => {
  //   if (watch("pin_code") && watch("pin_code").toString().length === 6) {
  //     const body = {
  //       pin_code: watch("pin_code"),
  //     };
  //     getZipDetails(body);
  //   }
  // }, [watch("pin_code")]);
  // const getZipDetails = (body) => {
  //   console.log("get zip details", watch("pin_code"));

  //   setLoading(true);
  //   getZipDetailsAPI(body)
  //     .then((res) => {
  //       setLoading(false);
  //       if (res.data.status === true) {
  //         const responseData = res.data.data[0];
  //         console.log("zip details", responseData);
  //         setValue("district", responseData.district_name);
  //         setValue("state", responseData.state_name);
  //       } else if (res.data.status === "expired") {
  //         toast.error(res.data.message);
  //         logout();
  //       } else if (res.data.status === false) {
  //         toast.error(res.data.message);
  //       }
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       toast.error(err?.response?.data?.message);
  //     });
  // };
  useEffect(() => {
    if (watch("pincode") && watch("pincode").toString().length === 6) {
      const body = {
        pin_code: watch("pincode"),
      };
      getZipDetails(body);
    }
  }, [watch("pincode")]);
  const getZipDetails = (body) => {
    console.log("get zip details", watch("pincode"));

    setLoading(true);
    getZipDetailsAPI(body)
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          const responseData = res.data.data[0];
          console.log(responseData);

          console.log("zip details", responseData);
          setValue("district", responseData.district_name);
          setValue("state", responseData.state_name);
          trigger(["state", "district"]);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (mode === "Edit") {
      getOneDetails();
    }
  }, [mode]);

  const getOneDetails = () => {
    getHospitalStepOne({ hospitalid: location.state.hospitalid })
      .then((res) => {
        if (res.data.status === true) {
          const data = res.data.data;
          console.log(data, "dataa");

          reset({
            name: data.name || "",
            hospital_type: data.hospitalType || null,
            regsitration_number: data.registrationNumber || "",

            hospital_mobile: data.contactNumber || "",
            contact_person: data.contactPerson || "",
            alternate_mobile: data.alternateContactNumber || "",
            email: data.email || "",
            pincode: data.pincode || "",
            district: data.district || "",
            state: data.state || "",
            // address:data.formatted_address||"",
            hospital_address: data.addressLine1 || "",
            address: data.addressLine2 || "",

            latitude: data.latitude || "",
            longitude: data.longitude || "",
            map_link: data.map_link || "",

            //  selectedAddress: {
            //     value: data.addressLine2 || data?.addressLine1,
            //   label: data.addressLine2|| data?.addressLine1
            //    },
          });
          setValue("selectedAddress", {
            value: data.addressLine2,
            label: data.addressLine2,
          });
          setMode("Edit");
        } else if (res.data.status === "expired") {
          logout();
        }
      })
      .catch(() => {
        toast.error("Failed to fetch hospital details");
      });
  };

  return (
    <>
      <Head title={"Hospita Registration | Hospital Profile"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Hospital Registration"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    navigate("/hospital-list");
                  }}
                >
                  <Icon name={"arrow-left"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <StepHeader current={1} />
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row className=" ">
                <div className="d-flex gap-5 py-3 mb-3">
                  {" "}
                  <h5>{"Hospital Details"}</h5>
                </div>
                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Hospital Name"
                    name="name"
                    placeholder="Enter Hospital Name"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Hospital type"}
                    name={"hospital_type"}
                    placeholder={"Select Hospital type"}
                    required
                    options={watch("storeTypeDD")}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col lg="6">
                  <MyGmailAddressSearch
                    value={watch("selectedAddress")}
                    onChange={(val) => setValue("selectedAddress", val)}
                    watch={watch}
                    setValue={setValue}
                    errors={errors}
                    trigger={trigger}
                  />
                </Col>
                {/* <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Registration Number"
                    name="regsitration_number"
                    placeholder="Enter Registration  No"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  {/* <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Hospital Mobile Number"}
                    name={"hospital_mobile"}
                    placeholder={"Enter alternate mobile"}
                    required
                    readOnly={mode == "Edit"}
                    disabled={mode == "Approval"}
                  /> */}
                   <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Hospital Mobile Number"}
                    name={"hospital_mobile"}
                    placeholder={"Enter hospital mobile number"}
                    required
                    min={10}
                    max={10}
                    readOnly={mode == "Edit"}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="3">
                  <MyEmail
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Email Address"
                    name="email"
                    placeholder="Enter Email Address"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Contact person Name"
                    name="contact_person"
                    placeholder="Enter Contact person Name"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Alternate Mobile Number"}
                    name={"alternate_mobile"}
                    placeholder={"Enter alternate mobile"}
                    // required
                    disabled={mode == "Approval"}
                  />
                </Col>
                {/* <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Pin Code"}
                    name={"pin_code"}
                    placeholder={"Enter pin code"}
                    required
                    min={6}
                    max={6}
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Pin Code"}
                    name={"pincode"}
                    placeholder={"Enter pin code"}
                    required
                    min={6}
                    max={6}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"District"}
                    name={"district"}
                    placeholder={"Enter district"}
                    required
                    disabled={mode == "Approval"}
                    readonly
                  />
                </Col>
                {/* <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"State"}
                    name={"state"}
                    placeholder={"Enter state"}
                    // required
                    disabled={mode == "Approval"}
                    readonly
                  />
                </Col> */}
                {/* <Col md="12" className={``}>
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Hospital Full Address"}
                      name={"hospital_full_address"}
                      placeholder={"Hospital Full Address"}
                      required
                      // min={25}
                      // max={500}
                      cols={2}
                      row={2}
                    />
                  </Col> */}
                {/* <Col xs="12" sm="6" md="4" lg="3" className={``}>
                                    <MyInput
                                      register={register}
                                      watch={watch}
                                      setValue={setValue}
                                      trigger={trigger}
                                      errors={errors}
                                      title={"Pin Code"}
                                      name={"pincode"}
                                      placeholder={"Enter pin code"}
                                      required
                                      min={6}
                                      max={6}
                                      disabled={mode == "Approval"}
                                    />
                                  </Col> */}
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    clearErrors={clearErrors}
                    errors={errors}
                    title={"State"}
                    name={"state"}
                    placeholder={"Select state"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                {/* <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"City"}
                    name={"city"}
                    placeholder={"Select city"}
                    // required
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Address"}
                    name={"address"}
                    placeholder={"Enter address"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>{" "}
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Google Map"}
                    name={"map_link"}
                    placeholder={"Enter google map link"}
                    // required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Latitude"}
                    name={"latitude"}
                    placeholder={"Latitude"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Longitude"}
                    name={"longitude"}
                    placeholder={"Longitude"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                {/* <Col md="12" className={``}>
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Hospital Address"}
                    name={"hospital_address"}
                    placeholder={"Enter hospital address"}
                    required
                    // min={25}
                    // max={500}
                    cols={2}
                    row={2}
                  />
                </Col> */}
              </Row>

              {(mode == "Add" || mode == "Edit") && (
                <Row>
                  <Col md="12" className={``}>
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default HospitalStepOne;
